// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   Homework Module - Beautiful Styles
   ============================================ */

/* ============================================
   Subjects Page (SubjectsView)
   ============================================ */

.homework-subjects-page {
  padding: 20px;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8e0ff 100%);
}

.homework-subjects-grid {
  margin-top: 10px;
}

/* Subject Card */
.homework-subject-card {
  background: white;
  border: none;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  animation: slideUpHomework 0.6s ease forwards;
  opacity: 0;
  transform: translateY(30px);
}

@keyframes slideUpHomework {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.homework-subject-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);
}

.homework-subject-header {
  position: relative;
  padding: 35px 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.homework-subject-header::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -50%;
  width: 100%;
  height: 200%;
  background: rgba(255, 255, 255, 0.1);
  transform: rotate(30deg);
  pointer-events: none;
}

.homework-subject-icon {
  width: 65px;
  height: 65px;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
}

.homework-subject-icon i {
  font-size: 30px;
  color: white;
}

.homework-count-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  background: rgba(255, 255, 255, 0.95);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.homework-count-badge span {
  font-size: 14px;
  font-weight: 700;
  color: #667eea;
}

.homework-card-decoration {
  position: absolute;
  bottom: -25px;
  right: -25px;
  width: 80px;
  height: 80px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
}

.homework-subject-body {
  padding: 20px 15px;
  text-align: center;
}

.homework-subject-title {
  font-size: 15px;
  font-weight: 700;
  color: #333;
  margin: 0 0 12px 0;
  line-height: 1.3;
}

.homework-subject-action {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 13px;
  color: #667eea;
  font-weight: 600;
}

.homework-subject-action i {
  transition: transform 0.3s ease;
}

.homework-subject-card:hover .homework-subject-action i {
  transform: translateX(5px);
}

/* ============================================
   Homework Detail Page
   ============================================ */

.homework-detail-page {
  padding: 20px;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8e0ff 100%);
}

/* History Toggle Card */
.history-toggle-card {
  background: white;
  border: none;
  border-radius: 16px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 25px;
}

.history-toggle-card .card-body {
  padding: 16px 20px;
}

.toggle-info {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 600;
  color: #333;
}

.toggle-info i {
  font-size: 20px;
  color: #667eea;
}

.history-switch .form-check-input {
  width: 50px;
  height: 26px;
  cursor: pointer;
}

.history-switch .form-check-input:checked {
  background-color: #667eea;
  border-color: #667eea;
}

/* Homework Days List */
.homework-days-list {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

/* Day Card */
.homework-day-card {
  background: white;
  border: none;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  animation: slideUpHomework 0.6s ease forwards;
  opacity: 0;
  transform: translateY(30px);
}

/* Day Header */
.homework-day-header {
  padding: 20px 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
}

.homework-day-header::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -30%;
  width: 60%;
  height: 200%;
  background: rgba(255, 255, 255, 0.1);
  transform: rotate(30deg);
  pointer-events: none;
}

.day-info {
  display: flex;
  align-items: center;
  gap: 15px;
}

.day-icon {
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
}

.day-icon i {
  font-size: 22px;
  color: white;
}

.day-text {
  display: flex;
  flex-direction: column;
}

.day-name {
  font-size: 18px;
  font-weight: 700;
  color: white;
  margin: 0;
  line-height: 1.2;
}

.day-date {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.85);
  margin: 4px 0 0 0;
}

.day-task-count {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: rgba(255, 255, 255, 0.2);
  padding: 10px 18px;
  border-radius: 14px;
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
}

.task-number {
  font-size: 22px;
  font-weight: 700;
  color: white;
  line-height: 1;
}

.task-label {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.9);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 2px;
}

/* Day Body */
.homework-day-body {
  padding: 25px;
}

/* Subject Item */
.homework-subject-item {
  background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);
  border-radius: 16px;
  padding: 18px;
  animation: slideUpHomework 0.5s ease forwards;
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.3s ease;
}

.homework-subject-item:hover {
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.15);
}

.subject-item-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 15px;
  padding-bottom: 12px;
  border-bottom: 2px solid rgba(102, 126, 234, 0.1);
}

.subject-icon-small {
  width: 38px;
  height: 38px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.subject-icon-small i {
  font-size: 16px;
  color: white;
}

.subject-name {
  flex: 1 1;
  font-size: 16px;
  font-weight: 700;
  color: #333;
  margin: 0;
}

.homework-badge {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 20px;
}

/* Tasks List */
.homework-tasks-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.homework-task-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 15px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.homework-task-item:hover {
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  transform: translateX(5px);
}

.task-bullet {
  width: 24px;
  height: 24px;
  min-width: 24px;
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.task-bullet i {
  font-size: 12px;
  color: white;
}

.task-text {
  font-size: 14px;
  color: #555;
  line-height: 1.5;
  margin: 0;
}

/* No Data Messages */
.no-homework-message,
.no-subjects-message {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  color: #888;
  font-size: 14px;
  font-style: italic;
}

.no-homework-message i,
.no-subjects-message i {
  font-size: 18px;
  color: #667eea;
}

/* ============================================
   Responsive Styles
   ============================================ */

@media (max-width: 991.98px) {
  .homework-day-header {
    padding: 18px 20px;
  }

  .day-name {
    font-size: 16px;
  }

  .homework-day-body {
    padding: 20px;
  }
}

@media (max-width: 767.98px) {
  .homework-subjects-page,
  .homework-detail-page {
    padding: 15px;
  }

  .homework-subject-header {
    padding: 30px 15px;
  }

  .homework-subject-icon {
    width: 55px;
    height: 55px;
  }

  .homework-subject-icon i {
    font-size: 26px;
  }

  .homework-subject-title {
    font-size: 14px;
  }

  .history-toggle-card .card-body {
    padding: 14px 16px;
  }

  .toggle-info {
    font-size: 14px;
  }

  .homework-day-header {
    padding: 15px 18px;
    flex-wrap: wrap;
    gap: 15px;
  }

  .day-icon {
    width: 42px;
    height: 42px;
  }

  .day-icon i {
    font-size: 18px;
  }

  .day-name {
    font-size: 15px;
  }

  .day-date {
    font-size: 12px;
  }

  .day-task-count {
    padding: 8px 14px;
  }

  .task-number {
    font-size: 18px;
  }

  .homework-day-body {
    padding: 15px;
  }

  .homework-subject-item {
    padding: 15px;
  }

  .subject-name {
    font-size: 14px;
  }

  .homework-task-item {
    padding: 10px 12px;
  }

  .task-text {
    font-size: 13px;
  }
}

@media (max-width: 575.98px) {
  .homework-subjects-page,
  .homework-detail-page {
    padding: 10px;
  }

  .homework-subject-card {
    border-radius: 16px;
  }

  .homework-subject-header {
    padding: 25px 12px;
  }

  .homework-subject-icon {
    width: 48px;
    height: 48px;
    border-radius: 14px;
  }

  .homework-subject-icon i {
    font-size: 22px;
  }

  .homework-count-badge {
    width: 28px;
    height: 28px;
    top: 10px;
    right: 10px;
  }

  .homework-count-badge span {
    font-size: 12px;
  }

  .homework-subject-body {
    padding: 15px 12px;
  }

  .homework-subject-title {
    font-size: 13px;
    margin-bottom: 10px;
  }

  .homework-subject-action {
    font-size: 11px;
  }

  .history-toggle-card .card-body {
    padding: 12px 14px;
  }

  .toggle-info {
    font-size: 13px;
  }

  .toggle-info i {
    font-size: 18px;
  }

  .history-switch .form-check-input {
    width: 44px;
    height: 22px;
  }

  .homework-day-card {
    border-radius: 16px;
  }

  .homework-day-header {
    padding: 12px 15px;
  }

  .day-info {
    gap: 10px;
  }

  .day-icon {
    width: 38px;
    height: 38px;
    border-radius: 10px;
  }

  .day-icon i {
    font-size: 16px;
  }

  .day-name {
    font-size: 14px;
  }

  .day-date {
    font-size: 11px;
  }

  .day-task-count {
    padding: 6px 12px;
    border-radius: 10px;
  }

  .task-number {
    font-size: 16px;
  }

  .task-label {
    font-size: 10px;
  }

  .homework-day-body {
    padding: 12px;
  }

  .homework-subject-item {
    padding: 12px;
    border-radius: 12px;
  }

  .subject-item-header {
    gap: 10px;
    margin-bottom: 12px;
    padding-bottom: 10px;
  }

  .subject-icon-small {
    width: 32px;
    height: 32px;
    border-radius: 8px;
  }

  .subject-icon-small i {
    font-size: 14px;
  }

  .subject-name {
    font-size: 13px;
  }

  .homework-badge {
    font-size: 11px;
    padding: 3px 10px;
  }

  .homework-tasks-list {
    gap: 8px;
  }

  .homework-task-item {
    padding: 10px;
    gap: 10px;
    border-radius: 10px;
  }

  .task-bullet {
    width: 20px;
    height: 20px;
    min-width: 20px;
  }

  .task-bullet i {
    font-size: 10px;
  }

  .task-text {
    font-size: 12px;
  }

  .no-homework-message,
  .no-subjects-message {
    padding: 15px;
    font-size: 13px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/dashboards/components/homework-beautiful.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;;iDAEiD;;AAEjD;EACE,aAAa;EACb,iBAAiB;EACjB,6DAA6D;AAC/D;;AAEA;EACE,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,eAAe;EACf,4DAA4D;EAC5D,6CAA6C;EAC7C,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,4BAA4B;EAC5B,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,qCAAqC;EACrC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,iBAAiB;EACjB,6DAA6D;AAC/D;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,aAAa;AACb;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,6CAA6C;EAC7C,UAAU;EACV,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,YAAY;EACZ,oCAAoC;EACpC,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;EAClB,mBAAmB;EACnB,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,6CAA6C;EAC7C,UAAU;EACV,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,SAAS;AACX;;AAEA,qBAAqB;AACrB;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,cAAc;AAChB;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,SAAS;IACT,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,aAAa;IACb,eAAe;EACjB;AACF","sourcesContent":["/* ============================================\n   Homework Module - Beautiful Styles\n   ============================================ */\n\n/* ============================================\n   Subjects Page (SubjectsView)\n   ============================================ */\n\n.homework-subjects-page {\n  padding: 20px;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f5f7fa 0%, #e8e0ff 100%);\n}\n\n.homework-subjects-grid {\n  margin-top: 10px;\n}\n\n/* Subject Card */\n.homework-subject-card {\n  background: white;\n  border: none;\n  border-radius: 20px;\n  overflow: hidden;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  animation: slideUpHomework 0.6s ease forwards;\n  opacity: 0;\n  transform: translateY(30px);\n}\n\n@keyframes slideUpHomework {\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.homework-subject-card:hover {\n  transform: translateY(-10px);\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);\n}\n\n.homework-subject-header {\n  position: relative;\n  padding: 35px 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.homework-subject-header::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  right: -50%;\n  width: 100%;\n  height: 200%;\n  background: rgba(255, 255, 255, 0.1);\n  transform: rotate(30deg);\n  pointer-events: none;\n}\n\n.homework-subject-icon {\n  width: 65px;\n  height: 65px;\n  background: rgba(255, 255, 255, 0.25);\n  border-radius: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  backdrop-filter: blur(10px);\n}\n\n.homework-subject-icon i {\n  font-size: 30px;\n  color: white;\n}\n\n.homework-count-badge {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  background: rgba(255, 255, 255, 0.95);\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.homework-count-badge span {\n  font-size: 14px;\n  font-weight: 700;\n  color: #667eea;\n}\n\n.homework-card-decoration {\n  position: absolute;\n  bottom: -25px;\n  right: -25px;\n  width: 80px;\n  height: 80px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 50%;\n}\n\n.homework-subject-body {\n  padding: 20px 15px;\n  text-align: center;\n}\n\n.homework-subject-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #333;\n  margin: 0 0 12px 0;\n  line-height: 1.3;\n}\n\n.homework-subject-action {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #667eea;\n  font-weight: 600;\n}\n\n.homework-subject-action i {\n  transition: transform 0.3s ease;\n}\n\n.homework-subject-card:hover .homework-subject-action i {\n  transform: translateX(5px);\n}\n\n/* ============================================\n   Homework Detail Page\n   ============================================ */\n\n.homework-detail-page {\n  padding: 20px;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f5f7fa 0%, #e8e0ff 100%);\n}\n\n/* History Toggle Card */\n.history-toggle-card {\n  background: white;\n  border: none;\n  border-radius: 16px;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);\n  margin-bottom: 25px;\n}\n\n.history-toggle-card .card-body {\n  padding: 16px 20px;\n}\n\n.toggle-info {\n  display: flex;\n  align-items: center;\n  font-size: 15px;\n  font-weight: 600;\n  color: #333;\n}\n\n.toggle-info i {\n  font-size: 20px;\n  color: #667eea;\n}\n\n.history-switch .form-check-input {\n  width: 50px;\n  height: 26px;\n  cursor: pointer;\n}\n\n.history-switch .form-check-input:checked {\n  background-color: #667eea;\n  border-color: #667eea;\n}\n\n/* Homework Days List */\n.homework-days-list {\n  display: flex;\n  flex-direction: column;\n  gap: 25px;\n}\n\n/* Day Card */\n.homework-day-card {\n  background: white;\n  border: none;\n  border-radius: 20px;\n  overflow: hidden;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);\n  animation: slideUpHomework 0.6s ease forwards;\n  opacity: 0;\n  transform: translateY(30px);\n}\n\n/* Day Header */\n.homework-day-header {\n  padding: 20px 25px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: relative;\n  overflow: hidden;\n}\n\n.homework-day-header::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  right: -30%;\n  width: 60%;\n  height: 200%;\n  background: rgba(255, 255, 255, 0.1);\n  transform: rotate(30deg);\n  pointer-events: none;\n}\n\n.day-info {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.day-icon {\n  width: 50px;\n  height: 50px;\n  background: rgba(255, 255, 255, 0.25);\n  border-radius: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  backdrop-filter: blur(10px);\n}\n\n.day-icon i {\n  font-size: 22px;\n  color: white;\n}\n\n.day-text {\n  display: flex;\n  flex-direction: column;\n}\n\n.day-name {\n  font-size: 18px;\n  font-weight: 700;\n  color: white;\n  margin: 0;\n  line-height: 1.2;\n}\n\n.day-date {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.85);\n  margin: 4px 0 0 0;\n}\n\n.day-task-count {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.2);\n  padding: 10px 18px;\n  border-radius: 14px;\n  backdrop-filter: blur(10px);\n}\n\n.task-number {\n  font-size: 22px;\n  font-weight: 700;\n  color: white;\n  line-height: 1;\n}\n\n.task-label {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.9);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-top: 2px;\n}\n\n/* Day Body */\n.homework-day-body {\n  padding: 25px;\n}\n\n/* Subject Item */\n.homework-subject-item {\n  background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);\n  border-radius: 16px;\n  padding: 18px;\n  animation: slideUpHomework 0.5s ease forwards;\n  opacity: 0;\n  transform: translateY(20px);\n  transition: all 0.3s ease;\n}\n\n.homework-subject-item:hover {\n  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.15);\n}\n\n.subject-item-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 15px;\n  padding-bottom: 12px;\n  border-bottom: 2px solid rgba(102, 126, 234, 0.1);\n}\n\n.subject-icon-small {\n  width: 38px;\n  height: 38px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.subject-icon-small i {\n  font-size: 16px;\n  color: white;\n}\n\n.subject-name {\n  flex: 1;\n  font-size: 16px;\n  font-weight: 700;\n  color: #333;\n  margin: 0;\n}\n\n.homework-badge {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  font-size: 12px;\n  font-weight: 600;\n  padding: 4px 12px;\n  border-radius: 20px;\n}\n\n/* Tasks List */\n.homework-tasks-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.homework-task-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 12px 15px;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease;\n}\n\n.homework-task-item:hover {\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);\n  transform: translateX(5px);\n}\n\n.task-bullet {\n  width: 24px;\n  height: 24px;\n  min-width: 24px;\n  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.task-bullet i {\n  font-size: 12px;\n  color: white;\n}\n\n.task-text {\n  font-size: 14px;\n  color: #555;\n  line-height: 1.5;\n  margin: 0;\n}\n\n/* No Data Messages */\n.no-homework-message,\n.no-subjects-message {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  color: #888;\n  font-size: 14px;\n  font-style: italic;\n}\n\n.no-homework-message i,\n.no-subjects-message i {\n  font-size: 18px;\n  color: #667eea;\n}\n\n/* ============================================\n   Responsive Styles\n   ============================================ */\n\n@media (max-width: 991.98px) {\n  .homework-day-header {\n    padding: 18px 20px;\n  }\n\n  .day-name {\n    font-size: 16px;\n  }\n\n  .homework-day-body {\n    padding: 20px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .homework-subjects-page,\n  .homework-detail-page {\n    padding: 15px;\n  }\n\n  .homework-subject-header {\n    padding: 30px 15px;\n  }\n\n  .homework-subject-icon {\n    width: 55px;\n    height: 55px;\n  }\n\n  .homework-subject-icon i {\n    font-size: 26px;\n  }\n\n  .homework-subject-title {\n    font-size: 14px;\n  }\n\n  .history-toggle-card .card-body {\n    padding: 14px 16px;\n  }\n\n  .toggle-info {\n    font-size: 14px;\n  }\n\n  .homework-day-header {\n    padding: 15px 18px;\n    flex-wrap: wrap;\n    gap: 15px;\n  }\n\n  .day-icon {\n    width: 42px;\n    height: 42px;\n  }\n\n  .day-icon i {\n    font-size: 18px;\n  }\n\n  .day-name {\n    font-size: 15px;\n  }\n\n  .day-date {\n    font-size: 12px;\n  }\n\n  .day-task-count {\n    padding: 8px 14px;\n  }\n\n  .task-number {\n    font-size: 18px;\n  }\n\n  .homework-day-body {\n    padding: 15px;\n  }\n\n  .homework-subject-item {\n    padding: 15px;\n  }\n\n  .subject-name {\n    font-size: 14px;\n  }\n\n  .homework-task-item {\n    padding: 10px 12px;\n  }\n\n  .task-text {\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .homework-subjects-page,\n  .homework-detail-page {\n    padding: 10px;\n  }\n\n  .homework-subject-card {\n    border-radius: 16px;\n  }\n\n  .homework-subject-header {\n    padding: 25px 12px;\n  }\n\n  .homework-subject-icon {\n    width: 48px;\n    height: 48px;\n    border-radius: 14px;\n  }\n\n  .homework-subject-icon i {\n    font-size: 22px;\n  }\n\n  .homework-count-badge {\n    width: 28px;\n    height: 28px;\n    top: 10px;\n    right: 10px;\n  }\n\n  .homework-count-badge span {\n    font-size: 12px;\n  }\n\n  .homework-subject-body {\n    padding: 15px 12px;\n  }\n\n  .homework-subject-title {\n    font-size: 13px;\n    margin-bottom: 10px;\n  }\n\n  .homework-subject-action {\n    font-size: 11px;\n  }\n\n  .history-toggle-card .card-body {\n    padding: 12px 14px;\n  }\n\n  .toggle-info {\n    font-size: 13px;\n  }\n\n  .toggle-info i {\n    font-size: 18px;\n  }\n\n  .history-switch .form-check-input {\n    width: 44px;\n    height: 22px;\n  }\n\n  .homework-day-card {\n    border-radius: 16px;\n  }\n\n  .homework-day-header {\n    padding: 12px 15px;\n  }\n\n  .day-info {\n    gap: 10px;\n  }\n\n  .day-icon {\n    width: 38px;\n    height: 38px;\n    border-radius: 10px;\n  }\n\n  .day-icon i {\n    font-size: 16px;\n  }\n\n  .day-name {\n    font-size: 14px;\n  }\n\n  .day-date {\n    font-size: 11px;\n  }\n\n  .day-task-count {\n    padding: 6px 12px;\n    border-radius: 10px;\n  }\n\n  .task-number {\n    font-size: 16px;\n  }\n\n  .task-label {\n    font-size: 10px;\n  }\n\n  .homework-day-body {\n    padding: 12px;\n  }\n\n  .homework-subject-item {\n    padding: 12px;\n    border-radius: 12px;\n  }\n\n  .subject-item-header {\n    gap: 10px;\n    margin-bottom: 12px;\n    padding-bottom: 10px;\n  }\n\n  .subject-icon-small {\n    width: 32px;\n    height: 32px;\n    border-radius: 8px;\n  }\n\n  .subject-icon-small i {\n    font-size: 14px;\n  }\n\n  .subject-name {\n    font-size: 13px;\n  }\n\n  .homework-badge {\n    font-size: 11px;\n    padding: 3px 10px;\n  }\n\n  .homework-tasks-list {\n    gap: 8px;\n  }\n\n  .homework-task-item {\n    padding: 10px;\n    gap: 10px;\n    border-radius: 10px;\n  }\n\n  .task-bullet {\n    width: 20px;\n    height: 20px;\n    min-width: 20px;\n  }\n\n  .task-bullet i {\n    font-size: 10px;\n  }\n\n  .task-text {\n    font-size: 12px;\n  }\n\n  .no-homework-message,\n  .no-subjects-message {\n    padding: 15px;\n    font-size: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
